import { useTranslate } from "../locales/hooks";
import { SupportedLanguages } from "../locales/interfaces";
import { NavigationItem } from "../modules/sunday-top-nav/navigation-menu";

const useNavigationItems = (language: SupportedLanguages): NavigationItem[] => {
  const t = useTranslate();

  return [
    {
      label: t("techRadarNavItem__label"),
      hint: t("techRadarNavItem__hint"),
      path: `/techradar/${language.toLowerCase()}`,
      isExternal: true,
    },
    {
      label: t("interviewNavItem__label"),
      hint: t("interviewNavItem__hint"),
      path: "/interview",
    },
    {
      label: t("storybookNavItem__label"),
      hint: t("storybookNavItem__hint"),
      path: "/storybook",
      isExternal: true,
      isNewTab: true,
    },
    {
      label: t("downloadNavItem__label"),
      hint: t("downloadNavItem__hint"),
      path: `/cv-${language.toLowerCase()}.pdf`,
      isExternal: true,
      download: `cv-${language.toLowerCase()}.pdf`,
    },
    {
      label: t("contactNavItem__label"),
      hint: t("contactNavItem__hint"),
      path: "/contact",
    },
    {
      label: t("myCvNavItem__label"),
      hint: t("myCvNavItem__hint"),
      path: "/cv",
    },
  ];
};

export { useNavigationItems };